import React, { useContext } from 'react';
import { Maybe, Price, Product, ProductProperties } from 'src/types';
import { VariantValues } from '../product-variants/types';

type Offers = {
  filteredOffers: Price[];
};

interface IProductContextValue {
  product?: Product & Maybe<{ coreProperties: ProductProperties }>;
  offers: Offers;
  allOffers: Price[];
  allOffersWithActiveAdditives: Price[];
  variantValues?: VariantValues;
}

const initialContextValue: IProductContextValue = {
  offers: { filteredOffers: [] },
  allOffers: [],
  allOffersWithActiveAdditives: [],
};

export const ProductContext = React.createContext<IProductContextValue>(
  initialContextValue
);

export const useProductContext = () => useContext(ProductContext);
